import { Scene, Group } from 'three';
import BimProduct from './BimProduct';
import Product from './Product';
import { IMaterialSet } from '../services/MaterialManager';
import { createMaterialPairs, disposeMaterialPairs } from '../components/SharedMaterialsCreator';
import MaterialPair from '../model/material/MaterialPair';
import Material from '../model/material/Material';
import { ElementTypeEnum } from '../elementTypeMappings';
import BimSpace from './bimProduct/BimSpace';
import createBimProduct from './bimProduct/BimProductFactory';
import { StageTypeEnum } from '../store/viewerState/ViewerMode/ViewerMode';

export class ModelManager {
    private static instance: ModelManager;
    
    roots: BimProduct[] = [];
    scene: Scene | null = null;
    modelGroup: Group = new Group();

    private _cachedMaterialPairs: Record<number, MaterialPair> = {};
    private _lastMaterials: Material[] | null = null;
    private _lastIsDebugMode: boolean | null = null;
    
    private constructor() { 
        this.modelGroup.name = "BIM Model";
    }

    static getInstance(): ModelManager {
        if (!ModelManager.instance) {
            ModelManager.instance = new ModelManager();
        }
        return ModelManager.instance;
    }

    init(scene: Scene) {
        if (this.scene != scene) {
            this.scene = scene;
            this.scene.add(this.modelGroup);
        }
    }
 
    // Revised update method
    update(products: Product[], visualizerApiUrl: string, setRootProductLoadingState: (globalId: string, isLoading: boolean) => void) {
        
        // Remove old
        this.roots.forEach(r => {
             // Can we do this in dispose?
             //if (this.scene) this.scene.remove((r.geometry as any).group); // Use any to access group for now or add to interface
             this.modelGroup.remove(r.group);
             r.dispose();
        });
        
        this.roots = products.map(p => createBimProduct(p, undefined) );
        
        this.roots.forEach(r => {
            
            setRootProductLoadingState(r.data.globalId, true);

            this.modelGroup.add(r.group);
        });
    }

    updateMaterials(materials: Material[], materialSet: IMaterialSet | undefined, isDebugMode: boolean, stageType?: StageTypeEnum) {
        if (materials !== this._lastMaterials || isDebugMode !== this._lastIsDebugMode) {
            disposeMaterialPairs(this._cachedMaterialPairs);
            this._cachedMaterialPairs = createMaterialPairs(materials, isDebugMode);
            this._lastMaterials = materials;
            this._lastIsDebugMode = isDebugMode;
        }
        this.roots.forEach(r => {
            r.updateRepresentations(this._cachedMaterialPairs, materialSet, stageType);
        });
    }

    onRotationOffsetChanged(rotationOffset: number) {
        this.roots.forEach(r => {
            r.onRotationOffsetChanged(rotationOffset);
        }); 
    }
}
